import './App.css';
import AllRoutes from './Routes/Allroutes';

function App() {
  return (
      <AllRoutes />
  );
}

export default App;
